import React, { Component } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { withRouter,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth,scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl,specialistURL} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import CKEditor from 'ckeditor4-react';


class Edit extends Component {
	fileObj = [];
    fileArray = [];
    imageArray = [];
	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const categoryId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		this.state = {
            categoryId: categoryId,
			cat_name:'',
			description:'',
			short_description:'',
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedtab:{value: 'both', label: 'All'},
			selectedtabvalue:'',
			selectedvalue:'',
			selectedModule:{ value: 'module1', label: 'Provider Listing' },
			selectedmodulevalue:'',
			image:'',
			image_name: '',
			image_preview: '',
			selectedcategoryvalue:'',
			productcategorynamelist:[],
			category_name:'',
			selectedcategoryid:'',
			selectedusertype:'',
			selectedusertypevalue:'',
			title_description:'',
			tabgalleries: '',
			selectid:'',
			imagepath:'',
			selected_image:'',
			tab_image:'',
			button_text:'',
			priority:'',
			domainlist:[],
			selecteddomain:'',
			selecteddomainvalue:'',
		};
		var qs = require('qs');
		var catid = this.state.categoryId;

		axios.get(apiUrl+"specialist/listdetail?id="+catid).then(res => {
			this.setState({image_name:res.data.categorylist.image,cat_name:res.data.categorylist.cat_name,priority:res.data.categorylist.priority, description:res.data.categorylist.description,short_description:res.data.categorylist.short_description});
			if( res.data.categorylist.title_description !== 'null'){
				this.setState({title_description: res.data.categorylist.title_description})
			}else{
				this.setState({title_description: ''})
			}
			if(res.data.categorylist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}


			if(res.data.categorylist.display == 'both'){
				this.setState({selectedtab:{value: 'both', label: 'All'}});
			}else if(res.data.categorylist.display == 'aiwidget'){
				this.setState({selectedtab:{value: 'aiwidget', label: 'Ai Widget'}});
			}else if(res.data.categorylist.display == 'normal'){
				this.setState({selectedtab: { value: 'normal', label: 'Default' } });
			}

			if(res.data.categorylist.module === 'module1'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'module1', label: 'Provider Listing'}});
			}else if(res.data.categorylist.module === 'module2'){
			this.setState({selectedModule:{value: 'module2', label: 'Product Listing'}});
			}else if(res.data.categorylist.module === 'module4'){
				this.setState({selectedModule: { value: 'module4', label: 'Ebag Products' }});
			}else if(res.data.categorylist.module === 'module5'){
				$('.category-section').hide();
				this.setState({selectedModule: { value: 'module5', label: 'Clinic List' }});
			}else if(res.data.categorylist.module === 'module6'){
				$('.category-section').hide();
				this.setState({selectedModule: { value: 'module6', label: 'Traveler List' }});
			}else if(res.data.categorylist.module === 'ai'){
				$('.category-section').hide();
				this.setState({selectedModule: { value: 'ai', label: 'AI Chat' }});
			}
			else if(res.data.categorylist.module === 'book'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'book', label: 'Book a Home Visit'}});
			}else if(res.data.categorylist.module === 'dashboard'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'dashboard', label: 'Dashboard'}});
			}else if(res.data.categorylist.module === 'ads'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'ads', label: 'Ads'}});
			}
			if(res.data.categorylist.product_category_id!=null && res.data.categorylist.product_category_id!=''){
			    this.setState({selectedcategoryvalue:res.data.categorylist.product_category_id,selectedcategoryid:res.data.categorylist.product_category_id});
			}

			if(res.data.categorylist.usertype!=null && res.data.categorylist.usertype!=''){
			    this.setState({selectedusertype:res.data.categorylist.usertype,selectedusertypevalue:res.data.categorylist.usertype});
			}
		
			if(res.data.categorylist.domain!=null && res.data.categorylist.domain!=''){
			    this.setState({selecteddomain:res.data.categorylist.domain,selecteddomainvalue:res.data.categorylist.domain});
			}

			this.setState({button_text:res.data.categorylist.button_text});
			this.setState({ tabgalleries: res.data.tabimageslist }, () => {
				console.log(this.state, 'productedit');
				// Render your galleries here using this.state.tabgalleries
			});
		}); 

		
		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'specialist/getproductcategorynamelist?admin_id='+admin_id)
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						productcategorynamelist:res.data.productcategorynamelist
					});
				
				}else{
				}
			});

			


		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
	    this.handleChangedisplaytab = this.handleChangedisplaytab.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onEditorChange1 = this.onEditorChange1.bind( this );
		this.onEditorChange = this.onEditorChange.bind( this );

    }
	componentDidMount() {
	

		document.title = PageTitle('Specialist Edit');
		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'plugin/getdomainlist?admin_id='+admin_id)
		.then(res => {
			if(res.data.status == 'success'){			
				this.setState({
					domainlist:res.data.domainlist
				});
			
			}else{
			}
		});	
    }

    handleChange = selectedOption => {

        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	handleChangedisplaytab = selectedtab => {
        this.setState({selectedtab})
        this.setState({  selectedtabvalue : selectedtab.value});
    };
	handleChangeModule = selectedModule => {

        this.setState({selectedModule})
        this.setState({  selectedmodulevalue : selectedModule.value});
		if(selectedModule.value == "module2")
		{
			$('.category-section').show();
		}else{
			this.setState({category_name: ''});
			$('.category-section').hide();
		}
    };
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name === 'cat_trending'){
      	this.setState({cat_trending_checked: !this.state.cat_trending_checked});
      }  		
    }
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			image_name1: file.name,
			image_preview: reader.result,
			image: file
		  });
		};
		reader.readAsDataURL(file);
	}

	
	
	

	
        handleFormSubmit = () => {

			if(this.validateForm()){ 
				// e.preventDefault();
					console.log('submit')
				this.setState({Loading:true});
				const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				var module = '';
				var category_name ="";
				var selectedcategorys='';
				var selectedusers='';
				var selecteddomains1='';
				var selecteddomains2='';
				var tab='';

				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				  status =formPayload.selectedOption.value;
				}else{
				  status = formPayload.selectedvalue;
				}
				if(formPayload.selectedmodulevalue === '' && formPayload.selectedmodulevalue!== 0){
					module =formPayload.selectedModule.value;
				}else{
					module = formPayload.selectedmodulevalue;
				}
				if(formPayload.selectedtabvalue === '' && formPayload.selectedtabvalue!== 0){
					tab =formPayload.selectedtab.value;
				}else{
					tab = formPayload.selectedtabvalue;
				}
				const selectedcategoryids = formPayload.selectedcategoryid;
				var elements=[];
				let catList  = ''
				if(typeof selectedcategoryids === 'object' && selectedcategoryids!=='' && typeof selectedcategoryids!==undefined && selectedcategoryids!==null) {
					catList = selectedcategoryids.map((number) =>
					elements.push(number.value)
				);
				selectedcategorys=elements.toString();

				}else{
					selectedcategorys=selectedcategoryids;

				}

				const selectedusertypes = formPayload.selectedusertype;
				var elements=[];
				let userList  = ''
				if(typeof selectedusertypes === 'object' && selectedusertypes!=='' && typeof selectedusertypes!==undefined && selectedusertypes!==null) {
					userList = selectedusertypes.map((number) =>
					elements.push(number.value)
				);
				selectedusers=elements.toString();
				}else{
					selectedusers=selectedusertypes;
				}


				const selecteddomains = formPayload.selecteddomain;
				// console.log(typeof selecteddomains,'selecteddomains');
				// console.log(formPayload.selectedusertype,'formPayload.selectedusertype');
				var elements2=[];
				var elements22=[];
				let catList2  = '';
					if(selecteddomains!=='' && typeof selecteddomains!==undefined && typeof selecteddomains!=='string'  && selecteddomains!==null) {
						catList2 = selecteddomains.map((number) =>
						elements2.push(number.value)
					);
					selecteddomains.map((number) =>
						elements22.push(number.label)
					);	
					selecteddomains1=elements2.toString();
					selecteddomains2=elements22.toString();
				}else{
					selecteddomains1=selecteddomains;
					selecteddomains2=selecteddomains;
				}	
				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					module: module,					
					product_category_id:selectedcategorys,
					usertypes:selectedusers,					
					domain:selecteddomains1,	
					domain_names:selecteddomains2,				
					name: formPayload.cat_name,
					priority:formPayload.priority,
					description: formPayload.description,
					short_description:formPayload.short_description,	
					title_description: formPayload.title_description,
					status:  status,
					display:tab,
					id: formPayload.categoryId,
					image: formPayload.image,
					button_text: formPayload.button_text,
				};
				let formData = new FormData();
				for(let k in postObject) {
					formData.append(k, postObject[k]);
				}	
				var filesdata = this.state.tab_image;
				var galleryimg = this.state.galleryimg;				
				if(galleryimg==2){
					for (var i in filesdata){
						formData.append('multiple_images[]',filesdata[i])
					}
				} 
				axios.post(apiUrl+"specialist/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								setTimeout(
								function() {
									$('.success_message').html(this.props.history.push('/specialist'));
								}
								.bind(this),
								3000
								);
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					}
				});
			}
	}

	validateForm() {
		const {cat_name,priority,selectedcategoryid,selectedusertype,selecteddomain,short_description,selectedmodulevalue,category_name} = this.state;
		let errors = {};
      	let formIsValid = true;
		
		if (!cat_name) {
			formIsValid = false;
			$('.errorcat_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(cat_name){
			$('.errorcat_name').html('');
		}

		if (!priority) {
			formIsValid = false;
			$('.errorpriority').html('<span class="errorspan">Please fill the field</span>');
		}else if(priority){
			$('.errorpriority').html('');
		}

		
		

		if (!short_description) {
			formIsValid = false;
			$('.errorshort_description').html('<span class="errorspan">Please fill the field</span>');
		}else if(short_description){
			$('.errorshort_description').html('');
		}

		if(selectedmodulevalue == 'module2'){
			if(!selectedcategoryid){
			formIsValid = false;
			$('.errorproductcategory').html('<span class="errorspan">Please fill the field</span>');
			}else{
				$('.errorproductcategory').html('');
			}
		}

		if(!selectedusertype){
			formIsValid = false;
			$('.errorusertype').html('<span class="errorspan">Please fill the field</span>');
		}else{
			$('.errorusertype').html('');
		}

		// if(!selecteddomain){
		// 	formIsValid = false;
		// 	$('.errordomain').html('<span class="errorspan">Please fill the field</span>');
		// }else{
		// 	$('.errordomain').html('');
		// }	

		this.setState({
			errors: errors
		});
		return formIsValid;
    }

	
	

    componentWillReceiveProps(Props){


   	if(Props.categorydetails !== this.props.categorydetails){
   		
    		if(Object.keys(Props.categorydetails).length > 0){
				this.setState({Loading:false});

					if(Props.categorydetails[0].status === "success"){
						const formdata = Props.categorydetails[0].categorylist;
						if(formdata.status === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
						if(formdata.display == 'both'){	
							this.setState({selectedtab:{value: 'both', label: 'All'}});
						}else if(formdata.display == 'aiwidget'){
							this.setState({selectedtab:{value: 'aiwidget', label: 'Ai Widget'}});
						}else if(formdata.display == 'normal'){
							this.setState({selectedtab: { value: 'normal', label: 'Default' } });
						}


						if(formdata.module === 'module1'){
							this.setState({selectedModule:{value: 'module1', label: 'Provider Listing'}});
						}else if(formdata.module === 'module2'){
							this.setState({selectedModule:{value: 'module2', label: 'Product Listing'}});
						}else if(formdata.module === 'book'){
							this.setState({selectedModule:{value: 'book', label: 'Book a Home Visit'}});
						}else if(formdata.module === 'module4'){
							this.setState({selectedModule: { value: 'module4', label: 'Ebag Products' }});
						}
						else if(formdata.module === 'module5'){
							this.setState({selectedModule: { value: 'module5', label: 'Clinic List' }});
						}else if(formdata.module === 'module6'){
							this.setState({selectedModule: { value: 'module6', label: 'Traveler List' }});
						}else if(formdata.module === 'ai'){
							this.setState({selectedModule: { value: 'ai', label: 'AI Chat' }});
						}else if(formdata.module === 'dashboard'){
							this.setState({selectedModule: { value: 'dashboard', label: 'Dashboard' }});
						}else if(formdata.module === 'ads'){
							this.setState({selectedModule: { value: 'ads', label: 'Ads' }});
						}
						this.setState({image_name:formdata.image});
						this.setState({cat_name:formdata.cat_name,priority:formdata.priority});
						this.setState({description: formdata.description});						
						this.setState({short_description: formdata.short_description});
					

						if( formdata.title_description !== 'null'){
							this.setState({title_description: formdata.title_description})
						}else{
							this.setState({title_description: ''})
						}

                        // this.setState({categoryId: formdata.id,selectedcategoryvalue:formdata.product_category_id});
						

						// var myArray = formdata.product_category_id.split(',');
						// console.log(formdata.product_category_id,'formdata.product_category_id')
						// console.log(myArray,'myArray')

						// if(Object.keys(myArray).length > 0){
						// 	const selectedcategoryid = [];
						// 	myArray.map(function(item){  
						// 		selectedcategoryid.push({
						// 	value: item[0].value,
						// 	label: item[0].label
						// 	});
						// 	});
						// 	this.setState({selectedcategoryid:selectedcategoryid});	
						// }

                        
					}
    		}
    	}

    	if(Props.categoryedit !== this.props.categoryedit){
    		if(Object.keys(Props.categoryedit).length > 0){
				if(Props.categoryedit[0].status === "success"){
    					this.setState({ Loading: false });

    			const formpayload = Props.categoryedit[0].categorylist;

				if(formpayload.status === 'A'){
					this.setState({selectedOption:{value: 'active', label: 'Active'}});
					}else{
					this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});	
					}	

					if(formpayload.display == 'both'){	
						this.setState({selectedtab:{value: 'both', label: 'All'}});
					}else if(formpayload.display == 'aiwidget'){
						this.setState({selectedtab:{value: 'aiwidget', label: 'Ai Widget'}});
					}else if(formpayload.display == 'normal'){
						this.setState({selectedtab: { value: 'normal', label: 'Default' } });
					}

					if(formpayload.module === 'module1'){
						this.setState({selectedModule:{value: 'module1', label: 'Provider Listing'}});
					}else if(formpayload.module === 'module2'){
						this.setState({selectedModule:{value: 'module2', label: 'Product Listing'}});
					}else if(formpayload.module === 'book'){
						this.setState({selectedModule:{value: 'book', label: 'Book a Home Visit'}});
					}else if(formpayload.module === 'module4'){
						this.setState({selectedModule: { value: 'module4', label: 'Ebag Products' }});
					}else if(formpayload.module === 'module5'){
						this.setState({selectedModule: { value: 'module5', label: 'Clinic List' }});
					}else if(formpayload.module === 'module6'){
						this.setState({selectedModule: { value: 'module6', label: 'Traveler List' }});
					}	else if(formpayload.module === 'ai'){
						this.setState({selectedModule: { value: 'ai', label: 'AI Chat' }});
					}else if(formpayload.module === 'dashboard'){
						this.setState({selectedModule: { value: 'dashboard', label: 'Dashboard' }});
					}else if(formpayload.module === 'ads'){
						this.setState({selectedModule: { value: 'ads', label: 'Ads' }});
					}	
					this.setState({image_name:formpayload.image});
					this.setState({cat_name:formpayload.cat_name,priority:formpayload.priority});
					this.setState({description: formpayload.description});						
					this.setState({short_description: formpayload.short_description});
					
					if( formpayload.title_description !== 'null'){
						this.setState({title_description: formpayload.title_description})
					}else{
						this.setState({title_description: ''})
					}

					this.setState({categoryId: formpayload.id});
			
                    	$('.success_message').html('<div class="status_sucess"><h3>'+ Props.categoryedit[0].message+'</h3></div>');
               			scrollToTop();
    					setTimeout(
						function() {
							$('.success_message').html(this.props.history.push('/specialist'));
						}
						.bind(this),
						3000
						);
						
    		}else{
					this.setState({ Loading: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ Props.categoryedit[0].message+'</h3></div>');
					scrollToTop();
    					setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
			}
			}
    	}		
    }
	handleProductCategoryChange = (event) => {  
		this.setState({selectedcategoryid : event}, function() {
		   const user_list = this.state.selectedcategoryid;
		});
   }
   	handleusertypeChange = (event) => {  
		this.setState({selectedusertype : event}, function() {
		//    const user_list = this.state.selectedusertype;
		});
	}

	handledomainChange = (event) => {  
		this.setState({selecteddomain : event}, function() {
		});
	}
   imageRemove = (Id) => {

	var postObject = {
		id:Id,
	};
	var qs = require('qs');

	axios.post(apiUrl+"specialist/deleteimage",qs.stringify(postObject) ).then(res => {
		if(res.data.status === "success"){	
			this.setState({image_name:res.data.categorylist.image,cat_name:res.data.categorylist.cat_name,priority:res.data.categorylist.priority, description:res.data.categorylist.description,short_description:res.data.categorylist.short_description, title_description: res.data.categorylist.title_description});
			if(res.data.categorylist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}

			if(res.data.categorylist.display == 'both'){
				this.setState({selectedtab:{value: 'both', label: 'All'}});
			}else if(res.data.categorylist.display == 'aiwidget'){
				this.setState({selectedtab:{value: 'aiwidget', label: 'Ai Widget'}});
			}else if(res.data.categorylist.display == 'normal'){
				this.setState({selectedtab: { value: 'normal', label: 'Default' } });
			}

			if(res.data.categorylist.module === 'module1'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'module1', label: 'Provider Listing'}});
			}else if(res.data.categorylist.module === 'module2'){
			this.setState({selectedModule:{value: 'module2', label: 'Product Listing'}});
			}else if(res.data.categorylist.module === 'modul4'){
				this.setState({selectedModule:{value: 'module4', label: 'Ebag Products'}});
			}else if(res.data.categorylist.module === 'modul5'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'module5', label: 'Clinic List'}});
			}else if(res.data.categorylist.module === 'modul6'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'module6', label: 'Traveler List'}});
			}else if(res.data.categorylist.module === 'ai'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'ai', label: 'AI Chat'}});
			}else if(res.data.categorylist.module === 'dashboard'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'dashboard', label: 'Dashboard'}});
			}else if(res.data.categorylist.module === 'ads'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'ads', label: 'Ads'}});
			}
			
			else if(res.data.categorylist.module === 'book'){
				$('.category-section').hide();
				this.setState({selectedModule:{value: 'book', label: 'Book a Home Visit'}});
				}

			if(res.data.categorylist.product_category_id!=null && res.data.categorylist.product_category_id!=''){
				this.setState({selectedcategoryvalue:res.data.categorylist.product_category_id});			
				this.setState({selectedcategoryid:res.data.categorylist.product_category_id});
			}
			if(res.data.categorylist.usertype!=null && res.data.categorylist.usertype!=''){
				this.setState({selectedusertype:res.data.categorylist.usertype,selectedusertypevalue:res.data.categorylist.usertype});
			}

			if(res.data.categorylist.domain!=null && res.data.categorylist.domain!=''){
				this.setState({selecteddomain:res.data.categorylist.domain,selecteddomainvalue:res.data.categorylist.domain});
			}

		}
	});
}

onEditorChange1( evt ) {
	// console.log(evt.editor.getData(), 'CKE')
	var callfunc = this;
	setTimeout(function () {
	callfunc.setState( {
		description: evt.editor.getData()
	} );
	}, 1000);
 
}

onEditorChange( evt ) {
	// console.log(evt.editor.getData(), 'CKE')
	var callfunc = this;
	setTimeout(function () {
	callfunc.setState( {
		short_description: evt.editor.getData()
	} );
	}, 1000);
 
}

confirmPopup = (id,imagepath,selected_image,type) => {
	this.setState({selectid: id,imagepath:imagepath,selected_image:selected_image, type: type})	
	$('.confirm-action').addClass('show');		
}
deleteimage(){
	var qs = require('qs');
	var postObject = {
	  admin_id : localStorage.getItem("admin_id"),
	  gallery_id  :this.state.selectid,
	  id  :this.state.tabId,
	  imagepath  :this.state.imagepath,
	  selected_image  :this.state.selected_image,
	  type: this.state.type
	};
	axios.post(apiUrl+"tabmanagement/deleteimage",qs.stringify(postObject)).then(res => {      
		  if(res.data.status === 'success'){
			if(this.state.type == 'product'){
				this.setState({productgalleries:res.data.productgalleries})
			}else{
				this.setState({tryoutgalleries:res.data.tryoutgalleries})
			}
			this.setState({ tabgalleries: res.data.productgalleries }, () => {
				// Render your galleries here using this.state.tabgalleries
			});
			$('.success_message').html('<div class="status_sucess"><h3> '+ res.data.message +' </h3></div>');
			setTimeout(function() {
				$('.success_message').html('');   
			}.bind(this),3000);
		  }
	}); 
}
Confirmstatus = (confirmstatus) => {
	if(confirmstatus == 'yes'){
	  this.deleteimage();
	  $('.confirm-action').removeClass('show');
	}else{
	  $('.confirm-action').removeClass('show');	
	}  
}
uploadMultipleFiles = (e) =>{
	this.fileObj = [];

		this.fileObj.push(e.target.files)
		for (let i = 0; i < this.fileObj[0].length; i++) {
			this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
			//this.fileArray.push(this.fileObj[0][i]
			this.imageArray.push(this.fileObj[0][i])

		}
		
		this.setState({ tab_image: this.imageArray,galleryimg:2,selectedimages:[] })		
	}
	removeImagebyindex = (indexvalue) => {
	   
		var list = [...this.imageArray];
		this.imageArray = [];
		this.fileArray = [];
		list.splice(indexvalue, 1);
	   
		for (let i = 0; i < list.length; i++) {
		  this.imageArray.push(list[i]);
		  this.fileArray.push(URL.createObjectURL(list[i]));
		}
	  
		  this.setState({ tab_image: this.imageArray })	
  }
  
  render() {
	  const {selectedOption,selectedtab,selectedModule,productcategorynamelist,selectedcategoryvalue,selectedusertype,selectedusertypevalue,selecteddomainvalue} = this.state;
	
	  let imageslist = [];

	  let indexlength =  imageslist.length;

	const gallerylocal =  this.fileArray && this.fileArray.map((url,index) => (
		<li className="thumb" key={indexlength+index}  >
			<span><img src={url}  alt="..." /></span>
			<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
		</li>
	))
		let loaderimg = '';
		let preview = '';

		  const imagepre = specialistURL+'/'+this.state.image_name;
		
		  if (this.state.id!=='' && imagepre!== null && imagepre!== '') {
			  loaderimg = specialistURL + '/'+this.state.image_name;
			  preview = <img className="img_class" src={loaderimg} alt="" />;
		  }else{
			  preview = <img className="img_class" src={imagepre} alt="" />;
		  }

    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="Specialist" />  
      <div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/specialist">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Edit Tab</h4>
			</div>
			 <form className="edit" id="edit"  encType="multipart/form-data">
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Tab Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="cat_name" onChange={this.handleInputChange} className="form-control" value={this.state.cat_name} />
					<div className="errorcat_name"></div>
				</div>
				<div className="form-group category-section">	
					<label>Product Category<span class="required" style={{ color: "red" }} > * </span> : </label>			
								
					<Multiselect
						displayValue="label"
						onRemove={this.handleProductCategoryChange}
						onSelect={this.handleProductCategoryChange}
						value={this.state.selectedcategoryid}
						selectedValues={productcategorynamelist.filter(obj => selectedcategoryvalue.includes(obj.value))}
						options={this.state.productcategorynamelist}
					/>
					<div className="errorproductcategory"></div>
				</div>

				<div className="form-group ">	
					<label> User Type<span class="required" style={{ color: "red" }} > * </span> : </label>			
						<Multiselect
							displayValue="label"
							onRemove={this.handleusertypeChange}

							onSelect={this.handleusertypeChange}
							value={this.state.selectedusertype}
							selectedValues={lang.common.account_type.filter(obj => selectedusertypevalue.includes(obj.value))}
							options={lang.common.account_type}
						/>
					<div className="errorusertype"></div>
				</div>
				<div className="form-group ">	
					<label> Domain<span class="required" style={{ color: "red" }} > * </span> : </label>			
						<Multiselect
							displayValue="label"
							onRemove={this.handledomainChange}

							onSelect={this.handledomainChange}
							// value={this.state.selecteddomain}
							selectedValues={this.state.domainlist.filter(obj => selecteddomainvalue.includes(obj.value))}
							options={this.state.domainlist}
						/>
					<div className="errorusertype"></div>
				</div>
				
				<div className="form-group ">	
					<label>Dispaly Tab : </label>			
						<Select 
						value={selectedtab?selectedtab:{value: 'both', label: 'All'}}
						options={lang.common.tabdisplay_option} 
						onChange={this.handleChangedisplaytab}
						/>
					{/* <div className="errorusertype"></div> */}
				</div>
				

				<div className="form-group">					
					<label>Short Description<span class="required" style={{ color: "red" }} > * </span>:</label>
					{/* 	<textarea type="text" name="short_description" onChange={this.handleInputChange} className="form-control" value={this.state.short_description}  /> */}
						<CKEditor
					data={this.state.short_description}
					//data={templatecontent}
					name="short_description" 
					onChange={this.onEditorChange}
					type="classic"
					/>
					<div className="errorshort_description"></div>
				</div>
				<div className="form-group">
					<label>Upload Mulitiple Images (jpeg,jpg,png,svg)<span class="required" style={{ color: "red" }} ></span>:</label>
					<div className="choose-file">
					{this.state.isHidden && <div className="image_success"></div>}
					<span className="profile_btn"><input type="file" name="file" onChange={this.uploadMultipleFiles} multiple /></span>
					</div>
					<ul className="carimagelisting">
										{/*imageslist*/}
									{gallerylocal}
									</ul>
					{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
					
				</div>
				<div className="form-row">
									{/* <div className="form-left"> */}
										{this.state.tabgalleries!=''?
										<div className="form-group">
											<div className='gallery-main clinic'>
												<label>Image Galleries</label>
												<div className='gallery-container'>
													{this.state.tabgalleries?.map((item) => (
													<div className='gallery-inner' key={item.id}>
														<img width="100px" height="100px" src={specialistURL+'/'+'tabimages'+'/'+item.tab_image} alt={`Image ${item.id}`}  />
														 <Link onClick={this.confirmPopup.bind(this, item.id,item.tab_image_path,item.tab_image,'tab')} className="" title="Delete">X</Link>
													</div>
													))}
												</div>
											</div>
										</div>:''}		
									{/* </div> */}
								</div>
											
				<div className="form-group">					
					<label>Status :</label>
					<Select 
					value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
					options={lang.common.status_option} 
					onChange={this.handleChange}
					/>
	           </div> 

			</div>
                  
			<div className="form-right">
			    <div className="form-group">					
				<label>Link to  <span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   name="module"
						   value={selectedModule?selectedModule:{ value: 'module1', label: 'Provider Listing'}}
                            options={lang.common.module_option} 
							isSearchable = {false}
                            onChange={this.handleChangeModule}
                            />
	           </div> 
				
			   <div className="form-group">
					<label>Priority<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="number" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority} />
					<div className="errorpriority"></div>
				</div>

				<div className="form-group">					
					<label>Description:</label>
				{/* 		<textarea type="text" name="description" onChange={this.handleInputChange} className="form-control" value={this.state.description}  /> */}
						<CKEditor
						data={this.state.description}
						//data={templatecontent}
						name="description" 
						onChange={this.onEditorChange1}
						type="classic"
						/>
					<div className="errordescription"></div>
				</div>
				

				<div className="form-group">					
					<label>Title Description<span class="required" style={{ color: "red" }} > * </span> :</label>
						<textarea type="text" name="title_description" onChange={this.handleInputChange} className="form-control" value={this.state.title_description}  />
				</div>
				<div className="form-group">
					<label>Icon:</label>
					<div className="choose-file">
					{this.state.isHidden && <div className="image_success"></div>}
					<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
					</div>
					{preview}
					{/* {loader_image_preview?<a href="javascript:void(0);">X</a>:''} */}
					{(this.state.image_name !==null && this.state.image_name !=='')?<a href="javascript:void(0);" onClick={this.imageRemove.bind(this,this.state.categoryId)}>X</a>:''}
				
					<div className="errorloaderimage"></div>  
				</div> 
				<div className="form-group">
					<label>Button Text</label>
				    <input type="text" name="button_text" onChange={this.handleInputChange} className="form-control" value={this.state.button_text} />
					<div className="errorbutton_text"></div>
				</div>
              

			</div>	
			</div>		

			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false} onClick={ this.handleFormSubmit.bind(this)} > {this.state.Loading ===true?
                                        <span>updating</span>:<span>Submit</span>
                                        }
                   </button>
			</div>
			</form>
			</div>				
		</div>	
	</div>
	<div className="confirm-action">
					<p>Are you sure! you want to delete this image?</p>
					<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
					<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
				</div>	
    </div>
    );
  }
}


// const mapStateTopProps = (state) => {
//   return {
//     categorydetails: state.categorydetails,
//     categoryedit: state.categoryedit
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getCategoryDetailList: (categoryId) =>{
//        dispatch({ type: GET_CATEGORYDETAILLIST,categoryId });
//     },
//     getEditCategory: (formPayload) =>{
//        dispatch({ type: GET_EDITCATEGORY, formPayload});
//     }
//   }
// }
export default (withRouter(Edit));